import React from 'react';
import { connect } from 'react-redux';
import FormElement from 'components/FormElement';
import {
  makeEmaiBillinglValidation,
  makeBillingPhoneValidation
} from 'helpers/ValidatorHelper';
import { handleInputChange } from 'actions/request';

const BillingPocAdd = ({ show, user, request, handleInputChange }) => {
  if (!show) return null;

  const emailValidation = makeEmaiBillinglValidation(request);
  const phoneValidation = makeBillingPhoneValidation(request);
  const isEditable = user.canEditRequest && !request.isPaid;

  return (
    <div>
      <FormElement
        type="text"
        id="billingPocFirstName"
        label="First Name"
        value={request.billingPocFirstName}
        onChange={handleInputChange}
        placeholder="First name for Billing PoC"
        editable={isEditable}
        maxLength={50}
      />
      <FormElement
        type="text"
        id="billingPocLastName"
        label="Last Name"
        value={request.billingPocLastName}
        onChange={handleInputChange}
        placeholder="Last Name for Billing PoC"
        editable={isEditable}
        maxLength={50}
      />
      <FormElement
        type="text"
        id="billingPocEmail"
        label="Billing PoC Email"
        value={request.billingPocEmail}
        onChange={handleInputChange}
        placeholder="Please enter a valid company email address"
        validationState={emailValidation.state}
        validationMessage={emailValidation.message}
        editable={isEditable}
        maxLength={50}
      />
      <FormElement
        type="text"
        id="billingPocPhone"
        label="Billing PoC Phone"
        value={request.billingPocPhone}
        onChange={handleInputChange}
        placeholder="Please enter a contact phone number"
        validationState={phoneValidation.state}
        validationMessage={phoneValidation.message}
        editable={isEditable}
        maxLength={18}
      />
    </div>
  );
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  { handleInputChange }
)(BillingPocAdd);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/BillingPocAdd.js